import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const Card = styled.div`
  text-align: left;
  height: 438px;
`;

const Info = styled.div`
  padding: 24px 16px 44px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Name = styled.div`
  color: #222222;
  font-size: 16px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
`;

const Education = styled.div`
  color: rgba(55, 56, 60, 0.61);
  font-size: 12px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
`;

const Career = styled.div`
  color: #222222;
  font-size: 14px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
`;

const ProgressBarWrapper = styled.div`
  margin-top: 40px;
  width: 100%;
  height: 2px;
  background: #e5eaf0;
  border-radius: 2px;
  overflow: hidden;
`;

const ProgressBar = styled.div`
  height: 3px;
  background: #171e26;
  transition: width 0.3s ease;
`;

const ArrowWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;

  img {
    width: 40px;
    height: 40px;
    cursor: pointer;
  }
`;

export const S = {
  Container,
  Card,
  Info,
  Name,
  Education,
  Career,
  ProgressBarWrapper,
  ProgressBar,
  ArrowWrapper,
};
